export default {
  edit: { id: 'edit' },
  title: { id: 'title' },
  dateUpdated: { id: 'date_updated' },
  saveInfo: { id: 'save_info' },
  sensorTypeTranslation: { id: 'sensor_type_translation' },
  sensorTypeList: { id: 'sensor_type_list' },
}
